import React from 'react';
import { Box, Typography, Button, Card } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../guards/jwt/JwtContext';
import { priceFormattingSymbol } from '../../utils/utils';
const PaymentSuccess = () => {
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const amount = params.get('amount');
  const currency = params.get('currency');
  const orderId = params.get('orderId');
  const { user } = useAuth();

  return (
    <Box p={3}>
      <Card sx={{ p: 4, textAlign: 'center', maxWidth: 600, mx: 'auto' }}>
        <CheckCircle 
          sx={{ 
            fontSize: 64, 
            color: 'success.main',
            mb: 2 
          }} 
        />
        <Typography variant="h4" gutterBottom>
          Payment Successful!
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Your payment has been processed successfully.
        </Typography>
        
        <Box sx={{ my: 3, p: 2, bgcolor: 'grey.50', borderRadius: 1 }}>
          <Typography variant="subtitle2" color="text.secondary">
            Payment Details
          </Typography>
          <Typography variant="h6">
            Amount Paid: {priceFormattingSymbol(amount,currency)}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            Order ID: {orderId}
          </Typography>
        </Box>

        {user && (
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate('/bookings')}
            sx={{ mt: 2 }}
          >
            Back to Bookings
          </Button>
        )}
      </Card>
    </Box>
  );
};

export default PaymentSuccess;